import { ConciergeState } from './types';
import { ConciergeAction, ConciergeActionKey, SetFetchingAgenciesAction, SetAgenciesAction } from './actions';

const initialState: ConciergeState = {
  isFetching: false,
  agencies: [],
};

export function conciergeReducer(state: ConciergeState = initialState, action: ConciergeAction): ConciergeState {
  switch (action.type) {
    case ConciergeActionKey.FETCH_AGENCIES:
      return {
        ...state,
      };

    case ConciergeActionKey.SET_FETCHING_AGENCIES:
      const isFetching = (action as SetFetchingAgenciesAction).data;
      return {
        ...state,
        isFetching: isFetching,
      };

    case ConciergeActionKey.SET_AGENCIES:
      const agencies = (action as SetAgenciesAction).data;
      return {
        ...state,
        agencies: agencies,
      };

    default:
      return state;
  }
}
